import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from '@angular/core';
import { ItemsDtoSingleResponse } from "@app/cem/project/services/item-management.service";
import { PlexEnvironment } from '@app/env';
import { IItemDto } from "@app/shared/models/dtos/item";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class ItemsRatesService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;

  ItemsDtoSingleResponse$: BehaviorSubject<ItemsDtoSingleResponse> = new BehaviorSubject(<ItemsDtoSingleResponse>{
    Result: <IItemDto>{
      ItemId: 0,
      FunctionId: null,
      ItemCategoryId: null,
      ItemSubCategoryId: null,
      PartNumber: null,
      OilCapacity: null,
      GasCapacity: null,
      WaterCapacity: null,
      CostCode: null,
      CostType: null,
      IsActive: null,
      CostTeamDto: null,
      ItemCategoryDto: null,
      ItemSubCategoryDto: null,
      CostCodeCostTypeDto: null,
      UnitOfMeasureDto: null,
    }
  });

  public getItemDto(): Observable<ItemsDtoSingleResponse> {
    return this.ItemsDtoSingleResponse$.asObservable();
  }

  private lastItemId: number = 0;

  public setItemDtoById(itemId: number): void {
    if (this.lastItemId === itemId) { return; }
    this.lastItemId = itemId;
    let url = `${this.BASE_URL}itemMaintenance/getitemdtobyid/` + itemId;
    this.http.get<ItemsDtoSingleResponse>(url)
      .subscribe(itemsDtoSingleResponse => {
        this.ItemsDtoSingleResponse$.next(itemsDtoSingleResponse);
      });
  }
}